import { connect } from 'react-redux';

import {
  CLOSE_AUDIO_PLAYER,
  LOAD_AUDIO,
  NEXT_AUDIO,
  OPEN_AUDIO_PLAYER,
  PAUSE_AUDIO_PLAYER,
  PLAY_AUDIO_PLAYER,
  PREV_AUDIO,
  RESET_AUDIO_PLAYER,
} from '../../redux/actions/audioPlayer';
import { getPlayList } from '../../redux/reducers/audioPlayer';
import ComponentErrorBoundary from '../ComponentErrorBoundary';
import type { AudioPlayerProps } from './AudioPlayer';
import AudioPlayer from './AudioPlayer';
import type { AudioPlayerDispatchers } from './AudioPlayers.type';

const stateToProps = (state): AudioPlayerProps => {
  return {
    ...state.audioPlayer,
    playlist: getPlayList(state.audioPlayer),
  };
};

const dispatchToProps = (dispatch): AudioPlayerDispatchers => {
  return {
    open: () => dispatch({ type: OPEN_AUDIO_PLAYER }),
    close: () => dispatch({ type: CLOSE_AUDIO_PLAYER }),
    play: () => dispatch({ type: PLAY_AUDIO_PLAYER }),
    pause: () => dispatch({ type: PAUSE_AUDIO_PLAYER }),
    load: () => dispatch({ type: LOAD_AUDIO }),
    next: () => dispatch({ type: NEXT_AUDIO }),
    prev: () => dispatch({ type: PREV_AUDIO }),
    reset: () => dispatch({ type: RESET_AUDIO_PLAYER }),
  };
};

const AudioPlayerComponent = connect(
  stateToProps,
  dispatchToProps,
)(AudioPlayer);

export default ComponentErrorBoundary(AudioPlayerComponent);
